interface Props {
    hasFocus: boolean;
    isGreater: boolean;
    length: number;
    maxLength: number | undefined;
}

export const MaxLengthDisplayBase = ({
    hasFocus,
    isGreater,
    length,
    maxLength,
}: Props): React.ReactElement | null => {
    if (!maxLength) {
        return null;
    }

    return (
        <span className="position-relative">
            <span
                className={`${isGreater ? 'text-danger' : 'text-muted'} ${
                    hasFocus ? 'd-inline' : 'd-none'
                }`}
            >
                {length}/{maxLength}
            </span>
        </span>
    );
};
